import { render } from "./ProcesosRegistro.vue?vue&type=template&id=59b851db"
import script from "./ProcesosRegistro.vue?vue&type=script&lang=js"
export * from "./ProcesosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__